import debug from 'debug';

const log = debug('TactileIcon');

/**
 * Display a tactile icon in the container 
 */
class TactileIcon {

	constructor(element) {
		this.element = element;

		this.initialize();
	}

	initialize() {
		if (this.getSettings() === null) return;

		this.setup();
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;

			if (settings.type === false || settings.type === '') {
				settings = null;
			}
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	setup() {
		log('setup() - type', this.settings.type);
		import(`Minetilbud/Shared/Icons/tactile/icon_${this.settings.type}.svg`).then(response => {
			
			this.element.insertAdjacentHTML('afterbegin', response.default);
			
			// Set a theme if we have it, otherwise we display the icon in the neutral default
			if (this.settings.theme) {
				this.element.classList.add(`tactile-icon--${this.settings.theme}`);
			}
			
		}).catch(error => {
			log(`Tactile icon ${this.settings.type} not found`, error);
		});
	}
}

export default TactileIcon;
